import React from 'react'
import { VStack, HStack, Text, Image } from '@chakra-ui/react'
import { buildAssetUrlString } from '@!/Util/buildAssetUrlString'
import StoreCoinSvg from '@images/store_coin.svg'

export const CurrentCoinDisplay = ({ coinCount }) => (
  <VStack w="100%" py="16px" px="16px" bg="white" align="center" gap={2}>
    <Text fontSize="sm" color="label.secondary" lineHeight="18px">
      所有コイン
    </Text>
    <HStack gap={1}>
      <Image w="24px" h="24px" src={buildAssetUrlString(StoreCoinSvg)} />
      <Text fontSize="2xl" fontWeight="700" lineHeight="32px">
        {coinCount.toLocaleString()}
      </Text>
    </HStack>
    <Text fontSize="xs" color="label.secondary" lineHeight="16px">
      購入したコインはiOSアプリでのみ利用できます。
    </Text>
  </VStack>
)
